window.addEventListener('DOMContentLoaded', (event) => {
    window.$("#set_password").on('click', function(e) {
        window.$("#pwd").removeClass('invalid');
        window.$("#email").removeClass('invalid');
        window.$("#confirm_pwd").removeClass('invalid');
        window.$('.invalid-feedback-admin').remove();

        let pwd = $("#pwd").val();
        let email = $("#email").val();
        let confirm_pwd = $("#confirm_pwd").val();
        let match = false;
        if (!email) {
            window.$("#email").addClass('invalid').after('<div class="invalid-feedback-admin">Enter your registered email.</div>');
        } else if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) === false) {
            window.$("#email").addClass('invalid').after('<div class="invalid-feedback-admin">Enver valid email.</div>');
        }
        if (!pwd) {
            window.$("#pwd").addClass('invalid').after('<div class="invalid-feedback-admin">Enter password.</div>');
        }
        if (!confirm_pwd) {
            window.$("#confirm_pwd").addClass('invalid').after('<div class="invalid-feedback-admin">Enter confirm password.</div>');
        }
        if (pwd === confirm_pwd) {
            match = true;
        } else if (confirm_pwd && pwd !== confirm_pwd) {
            window.$("#confirm_pwd").addClass('invalid').after('<div class="invalid-feedback-admin">Confirm Password does not match.</div>');
        }

        if (pwd && confirm_pwd && match) {
            window.$('#cover-spin').show(0);
            let url = window.$("#setpasswordform").attr('data-url');
            window.$("#pwd").removeAttr('readOnly');
            window.$("#confirm_pwd").removeAttr('readOnly');
            window.axios({
                    method: "post",
                    url: url,
                    data: { email: $("#email").val(), token: $("#generate_token").val(), password: $("#pwd").val(), confirm: $("#confirm_pwd").val(), _token: window.$('meta[name="csrf-token"]').attr('content') }
                })
                .then(function(response) {
                    window.$('#cover-spin').hide(0);
                    window.toastr.success(response.data.message, response.statusText);
                    setTimeout(function() {
                        window.location = '/login';
                    }, 1500);
                    //window.location = response.data.redirectTo;
                })
                .catch(error => {
                    // console.log(Object.keys(error.response.data));
                    window.$('#cover-spin').hide(0);
                    if (error.response.status == 401) {
                        window.toastr.error(error.response.data.message, error.response.statusText);
                    } else {
                        for (const errorkey in error.response.data) {
                            if (errorkey == 'confirm') {
                                window.$("#confirm_pwd").addClass('invalid').after('<div class="invalid-feedback-admin">' + error.response.data[errorkey][0] + '</div>');
                            } else if (errorkey == 'email') {
                                window.$("#email").addClass('invalid').after('<div class="invalid-feedback-admin">' + error.response.data[errorkey][0] + '</div>');
                            }
                        }
                        $("#super_admin_pass").addClass('invalid').after('<div class="invalid-feedback-admin">' + error.response.data.message + '</div>');
                        return false;
                    }
                })
        }
    });
});